<template>
  <footer class="footer hidden-xs-down">
    <p>
      Powered by <a :href="companyURL" target="_blank">{{ company }}</a> - ©{{ getCurrentYear }}
    </p>
  </footer>
</template>

<script>
import AppHelper from "../helper";
import {getEnvVar} from '@/utils/env';

export default {
  computed: {
    company() {
      if (!AppHelper.empty(getEnvVar('VUE_APP_TARGET_COMPANY'))) {
        return getEnvVar('VUE_APP_TARGET_COMPANY')
      }

      return 'Initiative'
    },

    companyURL() {
      if (!AppHelper.empty(getEnvVar('VUE_APP_TARGET_COMPANY_URL'))) {
        return getEnvVar('VUE_APP_TARGET_COMPANY_URL')
      }

      return 'https://www.initiative-crm.com/rgpd-crm-donnees-personnelles/'
    },
    getCurrentYear() {
      return new Date().getFullYear();
    }
  },
}
</script><style lang="scss">@import "@/assets/scss/layout/_footer.scss";</style>